import moment from 'moment'
import { DateHandler } from '@angle/utils'
import { IGroupChoiceDTO } from '../../../../services/quote/dto'
import {
  LEVEL_FUNDED,
  ACA_FULLY_INSURED,
  FULLY_INSURED_NON_ACA,
  SELF_FUNDED
} from '../../../../utils'

export const getDefaultPepm = (group?: IGroupChoiceDTO) => {
  if (!group || !group.state) return null
  return group.state === 'UT' ? '40' : '35'
}

export const getEffectiveDateList = () => {
  const dates: string[] = []
  const startOfNextMonth = moment().startOf('month')

  for (
    let date = startOfNextMonth.clone();
    date <= startOfNextMonth.clone().add(1, 'year');
    date.add(1, 'month')
  ) {
    dates.push(DateHandler.formatForClient(date.clone().toDate()))
  }
  return dates
}

export const byobStepsCopy = [
  {
    step: 1,
    title: 'Basic Quote Info',
    desc: 'Provide group information, effective date, and choose network and PBM preferences'
  },
  {
    step: 2,
    title: 'Plan Info',
    desc: 'Select desired pans, customize to fit your requirements, and explore additional services'
  },
  {
    step: 3,
    title: 'Census Info',
    desc: "Upload your group's census data or manually add members"
  },
  {
    step: 4,
    title: 'Quote Details',
    desc: 'Optionally provide historical plan and group information for a more accurate quote'
  },
  {
    step: 5,
    title: 'Quote Review',
    desc: 'Carefully review the quoted information, make edits or re-quote if needed, and finalize your proposal'
  }
]

export const possibleFundingTypes = [
  { value: LEVEL_FUNDED, label: 'Level Funded' },
  { value: ACA_FULLY_INSURED, label: 'ACA Fully Insured' },
  { value: FULLY_INSURED_NON_ACA, label: 'Fully Insured (Non-ACA)' },
  { value: SELF_FUNDED, label: 'Self funded' }
]
